module.exports = __webpack_public_path__ + "img/linkedin-btn.7509041e.svg";